
//Représente la requête d'activation / désactivation des pièces de vente (SU #118690)
//  La liste porte les lignes cochées de la grille, à défaut la ligne au focus. Elle ne peut pas
//  être vide : la route la refuse, et le menu est grisé sans sélection.
//  L'état cible est explicite et s'applique à toute la sélection — un basculement ligne par ligne
//  sur des lignes d'états mêlés donnerait un résultat imprévisible pour l'utilisateur.
export class MettreAJourActivationPiecesVenteRequest {
    //Identifiants des pièces de vente sélectionnées dans la grille
    public pieceIds!: string[];

    //Vrai pour désactiver les pièces, faux pour les réactiver
    public desactiver!: boolean;
}

//Représente le résultat de l'activation / désactivation des pièces de vente (SU #118690)
export class MettreAJourActivationPiecesVenteResultat {
    //Création
    constructor() {
        this.nombrePiecesModifiees = 0;
        this.nombrePiecesInchangees = 0;
        this.nombrePiecesNonAutorisees = 0;
    }

    //Nombre de pièces dont l'état d'activation a réellement changé
    public nombrePiecesModifiees: number;

    //Nombre de pièces déjà dans l'état demandé, laissées intactes
    public nombrePiecesInchangees: number;

    //Nombre de pièces écartées faute d'habilitation sur leur structure, ou introuvables
    public nombrePiecesNonAutorisees: number;
}
